import { EditProject } from "./EditProject";
import withConnect from "./withConnect";

export const EditProjectConnected = withConnect(EditProject);
export default EditProjectConnected;
